/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/featuresSection.config.json';
import { VApplication } from '../../../../application';
import { BreadcrumbService } from '../../../../services/breadcrumbService';

export interface IFeatureSectionMethods extends IPluginMethodMap {
  getFeatureSectionProps(args: any): Promise<any>;
}
const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.BreadcrumbService') as BreadcrumbService;
};

export class FeatureSectionService implements IAgentPlugin {
  readonly methods: IFeatureSectionMethods;

  constructor() {
    this.methods = {
      getFeatureSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    // return{
    //   config:{ ...config, ...(breadcrumbItems || {}) }
    // }
    return { ...(config || {}) };
  }
}
